//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapGetters } from 'vuex'

// РФ:
const LON_MIN = 19.0
const LON_MAX = 180.0
const LAT_MIN = 41.0
const LAT_MAX = 82.0

export default {
  props: {
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentDocumentValidationErrors: 'getCurrentDocumentValidationErrors'
    }),
    coordinateOrderLonLat: function () {
      return this.$store.getters.getUserSetting('ui.common.coordinateOrder', 'lonlat') === 'lonlat'
    },
    validationLon: function () {
      if (this.resultValue.value) {
        return this.validationLocation(this.resultValue.value[0][0], LON_MIN, LON_MAX)
      } else {
        return null
      }
    },
    validationLat: function () {
      if (this.resultValue.value) {
        return this.validationLocation(this.resultValue.value[0][1], LAT_MIN, LAT_MAX)
      } else {
        return null
      }
    }
  },
  watch: {
    validationLon: function (result) {
      if (result === true) {
        if (this.getCurrentDocumentValidationErrors > 0) {
          this.setCurrentDocumentValidationErrors(this.getCurrentDocumentValidationErrors - 1)
        }
      } else {
        this.setCurrentDocumentValidationErrors(this.getCurrentDocumentValidationErrors + 1)
      }
    },
    validationLat: function (result) {
      if (result === true) {
        if (this.getCurrentDocumentValidationErrors > 0) {
          this.setCurrentDocumentValidationErrors(this.getCurrentDocumentValidationErrors - 1)
        }
      } else {
        this.setCurrentDocumentValidationErrors(this.getCurrentDocumentValidationErrors + 1)
      }
    }
  },
  methods: {
    ...mapActions({
      setCurrentDocumentValidationErrors: 'setCurrentDocumentValidationErrors'
    }),
    validationLocation: function (value, min, max) {
      if (value) {
        if (value < min || value > max || value.toString().length < 9) {
          return false
        }
      }
      return true
    },
    ruleLocation: function (value, min, max) {
      if (value) {
        if (value < min || value > max) {
          return 'Неверное значение'
        }
        if (value.toString().length < 9) {
          return 'Необходимо заполнить 6 знаков после запятой'
        }
      }
      return true
    },
    ruleLat: function (value) {
      return this.ruleLocation(value, LAT_MIN, LAT_MAX)
    },
    ruleLon: function (value) {
      return this.ruleLocation(value, LON_MIN, LON_MAX)
    }
  }
}

